import Vuemit from './core/Vuemit'
import Mentions from './core/Mentions'
import localforage from 'localforage'
import Vue from 'vue'

window.debug = process.env.NODE_ENV === 'development'

window._ = require('lodash')
window.Vue = Vue
window.axios = require('axios')
window.URI = require('urijs')
//window.moment = require('moment')
//window.Chart = require('chart.js') // TODO: remove from here and include it only in pages where it is used

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['Accept-Language'] = ''

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

window.Vuemit = new Vuemit()
window.Mentions = Mentions

// for API
if (location.href.includes('/api/')) {
    // get cookie from document by name
    const getCookie = (name) => {
        const value = '; ' + document.cookie
        const parts = value.split('; ' + name + '=')
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift()
        }
    }

    // set default axios settings
    // set base url for api
    axios.defaults.baseURL = `${location.origin}/api/`
    // set bearer token
    axios.defaults.headers.common.Authorization = getCookie('authorization')
}

localforage.config({ storeName: 'Vitad.io' })
